import React, { useState, useEffect } from 'react';
import Modal from '../ui/Modal';
import InputField from '../ui/InputField';
import GlassButton from '../ui/Button';

const CategoryFormModal = ({ isOpen, onClose, onSave, categoryToEdit }) => {
    const [name, setName] = useState('');

    useEffect(() => {
        if (categoryToEdit) {
            setName(categoryToEdit.name || '');
        } else {
            setName('');
        }
    }, [categoryToEdit, isOpen]);

    const handleSave = () => {
        if (name.trim()) {
            onSave({ ...categoryToEdit, name });
            onClose();
        }
    };
    
    const title = categoryToEdit ? 'Editar Categoria' : 'Nova Categoria';
    const footer = (
        <>
            <GlassButton onClick={onClose} variant="minimal">Cancelar</GlassButton>
            <GlassButton onClick={handleSave} className="!bg-indigo-500">Salvar</GlassButton>
        </>
    );

    return (
        <Modal isOpen={isOpen} onClose={onClose} title={title} footer={footer} maxWidth="max-w-md">
            <InputField
                label="Nome da Categoria"
                value={name}
                onChange={(e) => setName(e.target.value)}
                placeholder="Ex: Inspiração, Fontes, IA..."
                required
            />
        </Modal>
    );
};

export default CategoryFormModal;